var t;!function(t){t.status="status",t.actions="actions",t.date_range="dateRange",t.date="date",t.icon="icon",t.iconic="iconic"}(t||(t={}));export{t as TEMPLATE_TYPE};
//# sourceMappingURL=data.js.map
